var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.3 469.3",
    style: {
      enableBackground: "new 0 0 469.3 469.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.7,149.3c-47.1,0-85.3,38.2-85.3,85.3s38.2,85.3,85.3,85.3s85.3-38.2,85.3-85.3S281.8,149.3,234.7,149.3z  M425.4,213.3C415.6,124.4,345,53.8,256,43.9V0h-42.7v43.9c-89,9.8-159.6,80.4-169.4,169.4H0V256h43.9 c9.8,89,80.4,159.6,169.4,169.4v43.9H256v-43.9c89-9.8,159.6-80.4,169.4-169.4h43.9v-42.7L425.4,213.3L425.4,213.3z M234.7,384 c-82.5,0-149.3-66.9-149.3-149.3S152.2,85.3,234.7,85.3S384,152.2,384,234.7S317.1,384,234.7,384z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.d809544d.svg";
export { ForwardRef as ReactComponent };